/**
 * Listings API
 */
export default class Listings {
  constructor(axios) {
    this.$axios = axios
  }

  List() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/listings',
      })
        .then(({ data }) => {
          resolve(data.listings)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  Get(id) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: `/listings/${id}`,
      })
        .then(({ data }) => {
          data.listing.kijiji.locationID = parseInt(data.listing.kijiji.locationID) || null
          data.listing.kijiji.categoryID = parseInt(data.listing.kijiji.categoryID) || null

          resolve(data.listing)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  Create(listing) {
    return new Promise((resolve, reject) => {
      // Enforce types
      listing.id = 0
      listing.kijiji.active = !!listing.kijiji.active
      listing.kijiji.locationID = parseInt(listing.kijiji.locationID) || 0
      listing.kijiji.categoryID = parseInt(listing.kijiji.categoryID) || 0
      listing.kijiji.price = parseFloat(listing.kijiji.price) || 0.00

      this.$axios({
        method: 'put',
        url: '/listings',
        data: {
          listing
        }
      })
        .then(({ data }) => {
          data.listing.kijiji.locationID = parseInt(data.listing.kijiji.locationID) || null
          data.listing.kijiji.categoryID = parseInt(data.listing.kijiji.categoryID) || null

          resolve(data.listing)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  Update(listing) {
    return new Promise((resolve, reject) => {
      // Enforce types
      listing.id = parseInt(listing.id) || 0
      listing.kijiji.active = !!listing.kijiji.active
      listing.kijiji.locationID = parseInt(listing.kijiji.locationID) || 0
      listing.kijiji.categoryID = parseInt(listing.kijiji.categoryID) || 0
      listing.kijiji.price = parseFloat(listing.kijiji.price) || 0.00

      this.$axios({
        method: 'post',
        url: `/listings/${listing.id}`,
        data: {
          listing
        }
      })
        .then(({ data }) => {
          data.listing.kijiji.locationID = parseInt(data.listing.kijiji.locationID) || null
          data.listing.kijiji.categoryID = parseInt(data.listing.kijiji.categoryID) || null

          resolve(data.listing)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  Delete(listingID) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'delete',
        url: `/listings/${listingID}`
      })
        .then(() => {
          resolve()
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  UploadImage(image, listingID = 0) {
    const formData = new FormData()
    formData.append('image', image);

    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'put',
        url: listingID > 0 ? `/listings/${listingID}/images` : '/listings/images',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(({ data }) => {
          resolve(data.image)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  DeleteImage(imageURL, listingID) {
    imageURL = window.btoa(imageURL)

    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'delete',
        url: `/listings/${listingID}/images`,
        params: {
          url: imageURL
        }
      })
        .then(() => {
          resolve()
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  ListActivePosts(id) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: `/listings/${id}/posts/active`,
      })
        .then(({ data }) => {
          const { list, total } = data
          resolve({ list, total })
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  ListPreviousPosts(id, offset = 0, limit = 5) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: `/listings/${id}/posts/previous`,
        params: {
          offset, limit
        }
      })
        .then(({ data }) => {
          const { list, total } = data
          resolve({ list, total })
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }
}
